export default async function useActiveSearchProvider(): Promise<
  string | undefined
> {
  const shiftSearchEngineConfig = await getSearchEngineConfig()
  return shiftSearchEngineConfig?.short_name
}
